import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  widgetContainer: {
    textAlign: 'center',
    padding: theme.spacing(3)
  },
  firstRow: {
    '& .MuiTableBody-root > tr:nth-of-type(1)': {
      backgroundColor: theme.palette.secondary.FP200
    },
    '& .MuiTableBody-root > tr:nth-of-type(1) td *': {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium
    },
    '& .MuiTableBody-root > tr:nth-of-type(1) > td:first-child button': {
      display: 'none'
    }
  },
  additionalLeftPadding: {
    paddingLeft: theme.spacing(8)
  },

  mediumWeightRow: {
    '& .MuiTableCell-root': {
      fontWeight: theme.typography.fontWeightMedium
    }
  },
  regularWeightRow: {
    fontWeight: theme.typography.fontWeightRegular
  },
  lightWeightRow: {
    fontWeight: theme.typography.fontWeightLight
  },
  expandableButton: {
    marginRight: theme.spacing(1)
  },
  paddingLeft: {
    paddingLeft: theme.spacing(1)
  }
}));
